import type { OptimizerAuditV2Record } from '../../types/audit.types';

type AuditSubAccountResult = NonNullable<
  OptimizerAuditV2Record['subAccountResults']
>[number];

const fallbackSubAccountId = (accountType?: string | null) =>
  `audit-sub-account-${accountType ?? 'unknown'}`;

/** Post-trade cash: start cash + sells − buys. */
export const resolveSubAccountProposedCashCents = (
  result: AuditSubAccountResult,
): number => {
  const inputCashCents = result.inputCashCents ?? 0;

  if (result.totalBuyCents != null || result.totalSellCents != null) {
    return (
      inputCashCents +
      (result.totalSellCents ?? 0) -
      (result.totalBuyCents ?? 0)
    );
  }

  const netHoldingDeltaCents = (result.weightDiffs ?? []).reduce(
    (sum, diff) => sum + (diff.deltaCents ?? 0),
    0,
  );

  return inputCashCents - netHoldingDeltaCents;
};

export const resolveProposedCashCentsFromAudit = (
  audit: OptimizerAuditV2Record | undefined,
): number => {
  const seenSubAccountIds = new Set<string>();
  let proposedCashCents = 0;

  for (const result of audit?.subAccountResults ?? []) {
    const subAccountId =
      result.subAccountId ?? fallbackSubAccountId(result.accountType);

    if (seenSubAccountIds.has(subAccountId)) {
      continue;
    }

    seenSubAccountIds.add(subAccountId);
    proposedCashCents += resolveSubAccountProposedCashCents(result);
  }

  return proposedCashCents;
};
